import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { DcrModule } from '@ddt-web/dcr';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { PaginationModule } from '@ddt-web/table';

import { DataTableComponent, SecuritiesTableComponent } from './table';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		GenericDirectivesModule,
		MatTooltipModule,
		DcrModule,
		PaginationModule,
		DomModule
	],
	declarations: [SecuritiesTableComponent, DataTableComponent],
	exports: [SecuritiesTableComponent, DataTableComponent]
})
export class SecuritiesTableModule { }
